
$(function () {
  $("#formForgot").on("submit", function (e) {
    e.preventDefault();
        const urlEmpresa = localStorage.getItem("urlEmpresa") ? localStorage.getItem("urlEmpresa")  : window.location.pathname.split('/').filter(Boolean)[0];

    const data = new FormData(this);
    data.append("empresa", urlEmpresa);
    $.ajax({
      url: "/ajax/ajax._re.php",
      method: "POST",
      data,
      cache: false,
      contentType: false,
      processData: false,
      dataType: "json",
      success: respuesta => {
 console.log("respuesta ", respuesta);
        fncFormatInputs();

        if (respuesta.status == 200) {
          fncSweetAlertTimer("alert", "¡Bienvenido!", "¡su solicitud fue exitosa, revise su correo electrónico para continuar!", `/${urlEmpresa}/inicio`);
          this.reset();
          $('#formForgot .was-validated').removeClass('was-validated');
        } else {
          fncSweetAlert("error", null, "¡No se pudo procesar su solicitud, inténtelo nuevamente!", window.location.pathname);
        }
      }
    });
  });
});